// 系统语言
export const appLanguage = 'zh-CN'
export const appDebugger = false
